<template>
  <section class="containerNotificationsSubMenu"
    :style="notificationsMenuStyle"
    :class="{mobile: mobile}"
    v-click-away="close"
    ref="notificationsSubMenu">
    <section class="containerNotificationsSubMenu__title">
      <label class="containerNotificationsSubMenu__title--lable">Notifications</label>
      <span class="containerNotificationsSubMenu__title--icon icon-grey-ellipsis"
        :style="unReadNotifications ? '--opacity: 0.59; --pointer-events: inherit; --cursor: pointer' : '--opacity: 0; --pointer-events: none; --cursor: default'"
        @click="optionsOpen = true">
      </span>
      <optionsNotificationComponent
        v-if="optionsOpen"
        v-click-away="closeOptions"
        :options="optionsNotification"
        general
        @markAllAsRead="markAllAsRead"
      >
      </optionsNotificationComponent>
    </section>
    <div v-if="emptyState" class="containerNotificationsSubMenu__empty" :style="notificationsEmptyStyle">
      <div class="containerNotificationsSubMenu__empty--icon">
        <img :src="require(`../../assets/no-notifications.svg`)">
      </div>
      <div class="containerNotificationsSubMenu__empty--message">You don't have notifications.</div>
    </div>
    <section v-else class="containerNotificationsSubMenu__data">
      <section class="containerNotificationsSubMenu__data--list customScrollbar"
        :style="notificationsMenuListStyle">
        <notification-list
          ref="newSection"
          v-if="notificationsAll.new.length"
          title="New"
          :notifications="notificationsAll.new"
          @close-notifications-menu="closeNotificationsSubMenu"
          @open-options="closeOtherModals('earlierSection')"
          @splice-notifications="spliceNotifications"
        >
        </notification-list>
        <notification-list
          ref="earlierSection"
          v-if="notificationsAll.earlier.length"
          title="Earlier"
          :notifications="notificationsAll.earlier"
          @close-notifications-menu="closeNotificationsSubMenu"
          @open-options="closeOtherModals('newSection')"
          @splice-notifications="spliceNotifications"
        >
        </notification-list>
      </section>
      <a class="containerNotificationsSubMenu__data--viewAll" :href="viewAllUrl" :target="_self">
        <span class="label">View All</span>
      </a>
    </section>
  </section>
</template>

<script>
import notificationList from '../notificationList/notificationList'
import optionsNotificationComponent from '../optionsNotification/optionsNotification'
import messages from '../../messages.json'
import { markAllAsReadService } from '../../services'
import { computed, onMounted, ref } from 'vue'

export default {
  name: 'notificationsSubMenu',
  props: {
    mobile: {
      type: Boolean,
      default: false
    },
    notificationsAll: {
      type: Object,
      required: true
    },
    viewAllUrl: {
      type: String,
      required: true
    }
  },
  components: {
    notificationList,
    optionsNotificationComponent
  },
  emits: ['close-notifications-menu', 'splice-notifications'],
  setup (props, { emit }) {
    const notificationsMenuStyle = ref('')
    const notificationsMenuListStyle = ref('')
    const notificationsEmptyStyle = ref('')
    const optionsNotification = ref([])
    const optionsOpen = ref(false)
    const notificationsSubMenu = ref(null)
    const newSection = ref(null)
    const earlierSection = ref(null)

    onMounted(() => {
      optionsNotification.value = messages.optionsNotification.general
      setNotificationsMenuStyle()
    })

    /**
     * @description Validate if empty state
     */
    const emptyState = computed(() => {
      return !props.notificationsAll.new.length && !props.notificationsAll.earlier.length
    })

    /**
     * @description Validate if there are at least one unread notification
     */
    const unReadNotifications = computed(() => {
      const unReadNotifications = [
        ...props.notificationsAll.new.filter(notification => !notification.isRead),
        ...props.notificationsAll.earlier.filter(notification => !notification.isRead)
      ]
      return unReadNotifications.length > 0
    })

    /**
     * @description Set the correct top style for modal
     */
    function setNotificationsMenuStyle () {
      if (!props.mobile) {
        const notifContainer = document.getElementById('notificationsId').getBoundingClientRect()
        notificationsMenuListStyle.value = `--height: ${notifContainer.bottom - 160}px`
        notificationsMenuStyle.value = `--top: -${notifContainer.bottom - 123}px`
        notificationsEmptyStyle.value = `--height: ${notifContainer.bottom - 146}px`
      } else {
        notificationsMenuListStyle.value = `--height: 426px`
        notificationsMenuStyle.value = `--top: 65px`
        notificationsEmptyStyle.value = `--height: 426px`
      }
    }

    /**
     * @description Emit method to close submenu when click outside
     * @param event Dom event
     */
    function close (event) {
      if (!event.target.classList.contains('notifications__bell')) {
        closeNotificationsSubMenu()
      }
    }

    /**
     * @description Emit method to close submenu
     */
    function closeNotificationsSubMenu () {
      emit('close-notifications-menu')
    }

    /**
     * @description Close options menu
     */
    function closeOptions () {
      optionsOpen.value = false
    }

    /**
     * @description Close other options modals
     * @param otherSection ref of other section
     */
    function closeOtherModals (otherSection) {
      closeOptions()
      switch (otherSection) {
        case 'newSection':
          if (newSection.value)
            newSection.value.closeOptions()
        break
        case 'earlierSection':
          if (earlierSection.value)
            earlierSection.value.closeOptions()
        break
      }
    }

    /**
     * @description Mark all notifications as read
     */
    function markAllAsRead () {
      markAllAsReadService().then(
        (response) => {
          if (response.data.success) {
            props.notificationsAll.new.map(notification => {
              notification.isRead = true
            })
            props.notificationsAll.earlier.map(notification => {
              notification.isRead = true
            })
            closeOptions()
          }
        },
        (error) => {
          console.error(error)
        }
      )
    }

    function spliceNotifications (config) {
      emit('splice-notifications', config)
    }

    return {
      markAllAsRead,
      emptyState,
      unReadNotifications,
      close,
      closeOtherModals,
      notificationsSubMenu,
      newSection,
      earlierSection,
      notificationsMenuStyle,
      notificationsMenuListStyle,
      notificationsEmptyStyle,
      optionsNotification,
      optionsOpen,
      closeNotificationsSubMenu,
      closeOptions,
      spliceNotifications
    }
  }
}
</script>
